import nanoajax from "nanoajax";
import PubSub from "pubsub-js";
import * as Sentry from "@sentry/browser";
import "../shared/pubsub-triggers";
import getURLParams from "../shared/getURLParams";
import { displayErrors } from "./utils";
import {
	$,
	trimInput,
	getCheckoutId,
	storeToken,
	requestSuccess,
	checkEmptyValue,
	urlCheckout,
	redirectLoggedUser,
	sendCookieDito
} from "../vanilla/utils";
import md5 from "blueimp-md5";
import { modalConstructor } from "../vanilla/modal";
import { showModalCheckoutError, getModalCheckoutError } from "../vanilla/modalCheckoutErrors";
import { showModalGPDR, showErrorLoginGDPR } from "../vanilla/modalGDPR";
import { CookieTypes, getCookie, removeCookie } from "../shared/cookie";

modalConstructor();

// testButton.classList.add('btn--is-loading');
// testButton.setAttribute("disabled", "disabled");

window.addEventListener("load", function() {
	localStorage.removeItem("au");
	removeCookie("au");

	verifyCheckoutId();

	$("#fblogin").disabled = false;
	$("#fblogin").setAttribute("aria-disabled", "false");
	$("#fblogin").onclick = submitFbLogin;

	$("#submitLogin").disabled = false;
	$("#submitLogin").setAttribute("aria-disabled", "false");
	$("#form-login").onsubmit = submitLogin;

	trimInput($("#login_username"));

	PubSub.publish("dataLayer", {
		event: "ditoTrack",
		ditoTrack: {
			action: "acessou-login"
		}
	});
});

export const submitLogin = function(event) {
	event.preventDefault();
	$("#div-error").style.display = "none";
	loginLoading(true);
	const username = $("#login_username").value.trim();
	const password = $("#login_password").value;
	if (!checkEmptyValue(username) && !checkEmptyValue(password)) {
		loginUser(username, password);
	} else {
		loginLoading(false);
	}
};

export const submitFbLogin = function(event = _event) {
	event.preventDefault();
	$("#div-error").style.display = "none";
	fbLoading(true);
	FB.login(
		function(response, _location = window.location) {
			if (response.authResponse === undefined) {
				fbLoading(false);
			} else {
				sendFBCredentialsAndRecirect(response, undefined, _location);
			}
		},
		{ scope: "email" }
	);
};

export const fbLoading = isLoading => {
	if (isLoading) {
		$("#fblogin").classList.add("btn--is-loading");
		$("#fblogin").disabled = true;
		$("#submitLogin").disabled = true;
		$("#submitLogin").setAttribute("aria-disabled", "true");
		$("#fblogin").setAttribute("aria-disabled", "true");
	} else {
		$("#fblogin").classList.remove("btn--is-loading");
		$("#fblogin").disabled = false;
		$("#submitLogin").disabled = false;
		$("#submitLogin").setAttribute("aria-disabled", "false");
		$("#fblogin").setAttribute("aria-disabled", "false");
	}
};

export const loginLoading = isLoading => {
	if (isLoading) {
		$("#submitLogin").classList.add("btn--is-loading");
		$("#submitLogin").disabled = true;
		$("#submitLogin").setAttribute("aria-disabled", "true");
		$("#fblogin").disabled = true;
		$("#fblogin").setAttribute("aria-disabled", "true");
	} else {
		$("#submitLogin").classList.remove("btn--is-loading");
		$("#submitLogin").disabled = false;
		$("#submitLogin").setAttribute("aria-disabled", "false");
		$("#fblogin").disabled = false;
		$("#fblogin").setAttribute("aria-disabled", "false");
	}
};

export const sendFBCredentialsAndRecirect = (
	fbCredentials,
	termsAccepted,
	_location = window.location
) =>
	nanoajax.ajax(
		{
			url: `/connect`,
			method: "POST",
			body: JSON.stringify({ ...fbCredentials.authResponse, termsAccepted }),
			headers: { "Content-Type": "application/json" }
		},
		(code, responseJSON) => {
			try {
				fbLoading(false);
				if (requestSuccess(code)) {
					storeToken(JSON.parse(responseJSON).token);

					// Verifica se o login retornou o parâmetro redirect
					const redirect = JSON.parse(responseJSON).redirect;
					if (!checkEmptyValue(redirect)) {
						try {
							// Redireciona o usuário para a página vinda na resposta do login
							const redirectLocation = new URL(redirect);
							setTimeout(function() {
								window.location = redirectLocation.href;
							}, 1);
							return;
						} catch (err) {
							Sentry.captureException(err);
						}
					}

					redirectLoggedUser(_location);
				} else {
					if (JSON.parse(responseJSON).type === "TermsNotAcceptedException") {
						showModalGPDR(
							() => sendFBCredentialsAndRecirect(fbCredentials, true),
							showErrorLoginGDPR
						);
					} else if (
						JSON.parse(responseJSON).type === "UsernameNotFoundException" ||
						JSON.parse(responseJSON).type === "NoResultException"
					) {
						window.location = "/cadastro?facebook=true";
					} else {
						userLoginFail(responseJSON, []);
					}
				}
			} catch (err) {
				loginLoading(false);
			}
		}
	);

const userLoginSuccess = (username, responseJSON, checkoutId) => {
	const flow = checkEmptyValue(checkoutId) ? "normal" : "compra";
	if (/([\w.-]+@([\w-]+)\.+\w{2,})/.test(username) !== null) {
		PubSub.publish("dataLayer", {
			event: "ditoIdentifyEmail",
			ditoIdentify: {
				email: username
			}
		});

		PubSub.publish("dataLayer", {
			event: "gaEvent",
			userId: md5(username),
			gaEventCategory: "Identificação de e-mail",
			gaEventAction: "Login",
			gaEventLabel: flow,
			gaEventValue: ""
		});

		const lastClick = getCookie("last_click", CookieTypes.PUBLICITY);
		const cac = getCookie("cac", CookieTypes.PUBLICITY);

		const lastClickAffiliateDito = sendCookieDito(lastClick, cac);

		PubSub.publish("dataLayer", {
			event: "ditoTrack",
			ditoTrack: {
				action: "login-dados",
				data: lastClickAffiliateDito
			}
		});
	}

	storeToken(JSON.parse(responseJSON).token);

	// Verifica se o login retornou o parâmetro redirect
	const redirect = JSON.parse(responseJSON).redirect;
	if (!checkEmptyValue(redirect)) {
		try {
			// Redireciona o usuário para a página vinda na resposta do login
			const redirectLocation = new URL(redirect);
			setTimeout(function() {
				window.location = redirectLocation.href;
			}, 1);
			return;
		} catch (err) {
			Sentry.captureException(err);
		}
	}

	// SetTimeout criado para migrar essa execução para a fila de processo "motivo - ditoTrack"
	setTimeout(function() {
		redirectLoggedUser();
	}, 1);
};

const userLoginFail = (response, data) => {
	const err =
		typeof response === "string" ? JSON.parse(response) : { type: "Internal Server Error" };

	displayErrors(err);
};

export const loginUser = (
	username,
	password,
	termsAccepted = undefined,
	_sessionStorage = window.sessionStorage,
	_location = window.location
) => {
	nanoajax.ajax(
		{ url: `/login`, method: "POST", body: JSON.stringify({ username, password, termsAccepted }) },
		(code, responseJSON) => {
			try {
				if (requestSuccess(code)) {
					const checkoutId =
						_sessionStorage.getItem("activeCheckoutId") || getURLParams(_location.href).id;
					userLoginSuccess(username, responseJSON, checkoutId);
				} else {
					if (JSON.parse(responseJSON).type === "TermsNotAcceptedException") {
						showModalGPDR(() => loginUser(username, password, true), showErrorLoginGDPR);
					} else {
						userLoginFail(responseJSON, [username, password]);
					}
				}
				loginLoading(false);
			} catch (err) {
				loginLoading(false);
			}
		}
	);
};

export const verifyCheckoutId = () => {
	const checkoutId = getCheckoutId();

	if (checkoutId) {
		nanoajax.ajax({ url: urlCheckout(checkoutId) }, (code, response) => {
			if (!requestSuccess(code)) {
				const errorContent = getModalCheckoutError(code);
				showModalCheckoutError(errorContent);
			}
		});
	}
};
